import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {News} from '../model/News';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private http: HttpClient) {
  }

  getLatestNews(): Observable<News[]> {
    return this.http.get<News[]>(`${environment.backend}/news`);
  }
}
